import { AxiosInstance } from 'axios';
import { ReservationService } from 'services/Reservations';

export interface ReservationCommonServiceModel {
  updateRoomComment: ReturnType<typeof ReservationService.updateRoomComment>;
  discard: ReturnType<typeof ReservationService.discard>;
  checkRoomavAvilability: ReturnType<typeof ReservationService.checkRoomavAvilability>;
  getAll: ReturnType<typeof ReservationService.getAll>;
  search: ReturnType<typeof ReservationService.search>;
  getGuest: ReturnType<typeof ReservationService.getGuest>;
  updateGuest: ReturnType<typeof ReservationService.updateGuest>;
  searchCardGroup: ReturnType<typeof ReservationService.searchCardGroup>;

  searchToBillingRouteEntity: ReturnType<typeof ReservationService.searchToBillingRouteEntity>;
  confirm: ReturnType<typeof ReservationService.confirm>;
  getArrivalReservationStates: ReturnType<typeof ReservationService.getArrivalReservationStates>;
}

export const initReservationCommonService = (
  axios: AxiosInstance
): ReservationCommonServiceModel => ({
  updateRoomComment: ReservationService.updateRoomComment(axios),
  discard: ReservationService.discard(axios),
  getAll: ReservationService.getAll(axios),
  search: ReservationService.search(axios),
  getGuest: ReservationService.getGuest(axios),
  updateGuest: ReservationService.updateGuest(axios),
  searchCardGroup: ReservationService.searchCardGroup(axios),
  searchToBillingRouteEntity: ReservationService.searchToBillingRouteEntity(axios),
  confirm: ReservationService.confirm(axios),
  checkRoomavAvilability: ReservationService.checkRoomavAvilability(axios),
  getArrivalReservationStates: ReservationService.getArrivalReservationStates(axios),
});
